export enum ProductTypeEnum {
  STOCKABLE = "Stockable",
  GENERAL = "General",
  SERVICE = "Service",
}
